export default {
      id: "ic_fb-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic_fb-usage",
      toString: function () {
        return this.url;
      }
    }